<template>
  <div class="class-1">
    <AppHeader title="Edit Printer" />
    
    <div class="container mt-4">
      <div class="row">
        <div class="col-12">
          <form @submit.prevent="submitForm" v-if="printer">
            <!-- Printer ID Input -->
            <div class="form-row">
              <div class="form-group col-md-12">
                <label for="printer_id">Printer ID</label>
                <input
                  type="text"
                  class="form-control"
                  id="printer_id"
                  placeholder="Enter Printer ID"
                  v-model="form.printer_id"
                  required
                  :readonly="true" 
                >
                <small class="form-text text-muted">
                  Printer identifier (cannot be changed)
                </small>
              </div>
            </div>

            <!-- Name Inputs for Each Language -->
            <div class="form-row" v-for="language in languages" :key="language.id">
              <div class="form-group col-md-12">
                <label :for="`name_${language.id}`">Name ({{ language.fullName }})</label>
                <input
                  type="text"
                  class="form-control"
                  :id="`name_${language.id}`"
                  :placeholder="`Enter Printer Name in ${language.fullName}`"
                  v-model="form.names[language.id]"
                  required
                >
              </div>
            </div>

            <!-- Buttons -->
            <div class="form-row">
              <div class="form-group col-12 d-flex justify-content-between">
                <button type="button" class="btn btn-secondary" @click="cancelForm">Cancel</button>
                <button type="submit" class="btn btn-primary">Update Printer</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      printer: null,
      languages: [],
      form: {
        printer_id: '',
        names: {}
      }
    };
  },
  mounted() {
    this.fetchLanguages();
    this.fetchPrinter();
  },
  methods: {
    fetchLanguages() {
      const storedLanguages = localStorage.getItem('languages');
      if (storedLanguages) {
        this.languages = JSON.parse(storedLanguages);
      }
    },
    async fetchPrinter() {
      try {
        this.$root.isLoading = true;
        const token = localStorage.getItem('authToken');
        const printerId = this.$route.params.id;
        
        const response = await fetch(`${this.$BASE_API_URL}/api/printers/${printerId}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          }
        });

        if (response.ok) {
          const { data } = await response.json();
          this.printer = data;
          // Populate form with existing data
          this.form.printer_id = data.printer_id || '';
          data.languages.forEach(lang => {
            this.form.names[lang.langId] = lang.name;
          });
        } else {
          throw new Error('Failed to fetch printer');
        }
      } catch (error) {
        console.error('Error fetching printer:', error);
        this.$toast.error('Failed to load printer data');
      } finally {
        this.$root.isLoading = false;
      }
    },
    async submitForm() {
      try {
        this.$root.isLoading = true;
        const token = localStorage.getItem('authToken');
        const printerId = this.$route.params.id;
        const branchId = localStorage.getItem('branchId');
        
        const payload = {
          printer_id: this.form.printer_id,
          branchId: branchId, // Include branchId for update as well
          names: this.languages.map(language => ({
            langId: language.id,
            name: this.form.names[language.id] || ''
          }))
        };

        const response = await fetch(`${this.$BASE_API_URL}/api/printers/${printerId}`, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
          body: JSON.stringify(payload)
        });

        if (response.ok) {
          this.$toast.success('Printer updated successfully!');
          this.$router.push({ name: 'PrintersManagement' });
        } else {
          const errorData = await response.json();
          throw new Error(errorData.message || 'Failed to update printer');
        }
      } catch (error) {
        console.error('Error updating printer:', error);
        this.$toast.error(error.message || 'Failed to update printer');
      } finally {
        this.$root.isLoading = false;
      }
    },
    cancelForm() {
      this.$router.go(-1);
    }
  }
};
</script>